import { useMemo } from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AddIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import useReactHookFormProps from '../../../../hooks/useReactHookFormProps';
import { getFormFields } from './constants';
import messages from './messages';

function AddMiscellaneousAccountingModal({
  open,
  intl,
  chargeCodeOptions,
  isSubmitting = false,
  onClose,
  onSubmit,
}) {
  const defaultValues = useMemo(
    () => ({
      requestType: '',
      comments: '',
      requestedAmount: null,
      propertyTransactionCodeId: '',
    }),
    [],
  );

  const reactHookFormProps = useReactHookFormProps({
    defaultValues,
    mode: 'onChange',
  });

  const handleClose = () => {
    onClose();
    reactHookFormProps.reset(defaultValues);
  };

  const handleSubmit = async (data) => {
    await onSubmit({
      requestType: String(data.requestType || '')
        .trim()
        .toUpperCase(),
      comments: String(data.comments || '').trim(),
      requestedAmount: Number(data.requestedAmount),
      propertyTransactionCodeId: data.propertyTransactionCodeId,
    });
    handleClose();
  };

  const formFields = useMemo(
    () => getFormFields(messages, intl, chargeCodeOptions),
    [intl, chargeCodeOptions],
  );

  const isSaveDisabled = !reactHookFormProps.isValid;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      icon={<AddIcon />}
      title={intl.formatMessage(messages.modalTitle)}
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              sm: 520,
            },
          },
        },
      }}
      actionsProps={[
        {
          children: intl.formatMessage(messages.cancel),
          onClick: handleClose,
        },
        {
          children: intl.formatMessage(messages.save),
          submitButton: true,
          isSubmitting: isSubmitting || reactHookFormProps.isSubmitting,
          disabled: isSaveDisabled,
          onClick: reactHookFormProps.handleSubmit(handleSubmit),
        },
      ]}
    >
      <Typography variant="bodyMedium" marginBottom={1.5} display="block">
        {intl.formatMessage(messages.modalDescription)}
      </Typography>
      <Form ReactHookFormProps={reactHookFormProps} fields={formFields} />
    </Modal>
  );
}

export default AddMiscellaneousAccountingModal;
